const BermudaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110905)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 20.0048 20 0.0021875 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#D80027"
      />
      <path d="M19.9999 9.56543V16.311L13.0435 9.56543H19.9999Z" fill="#0052B4" />
      <path
        d="M10.4345 19.9989H16.3103L10.4345 12.1729L9.56494 18.2598L10.4345 19.9989Z"
        fill="#0052B4"
      />
      <path
        d="M19.9468 19.9998H20.0003C20.0003 19.9818 20.0003 19.9643 20.0003 19.9463C19.9825 19.9642 19.9647 19.982 19.9468 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 10.4348C20 6.91563 20 4.60977 20 0H19.9966C8.95242 0.001875 0 8.95539 0 20H10.4348V14.1241L16.3106 20H19.9466C19.9644 19.9822 19.9822 19.9644 20.0001 19.9465C20.0001 18.5991 20.0001 17.3968 20.0001 16.3108L14.1241 10.4348H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1181 2.6084C6.99004 4.38957 4.38949 6.99004 2.6084 10.1181V20.8693H7.82582V7.82598V7.82582H20.8693C20.8693 6.18027 20.8693 4.61262 20.8693 2.6084H10.1181Z"
        fill="#D80027"
      />
      <path
        d="M20.7944 18.3353L12.8935 10.4346H10.4341V10.4347L20.7942 20.7948H20.7943C20.7944 20.7949 20.7944 19.099 20.7944 18.3353Z"
        fill="#D80027"
      />
      <path
        d="M22.6084 10.4346V19.9997C22.6084 24.6591 34.7823 24.6591 34.7823 19.9997V10.4346H22.6084Z"
        fill="#F3F3F3"
      />
      <path
        d="M22.6084 20.0001V20C22.6084 24.6594 28.6954 26.087 28.6954 26.087C28.6954 26.087 34.7823 24.6594 34.7823 20V20.0001H22.6084Z"
        fill="#6DA544"
      />
      <path
        d="M28.6952 16.1738L25.8691 17.3912V19.9999L28.6952 21.7391L31.5213 19.9999V17.3912L28.6952 16.1738Z"
        fill="#A2001D"
      />
      <path d="M25.8691 14.7832H31.5213V17.3919H25.8691V14.7832Z" fill="#338AF3" />
    </g>
    <defs>
      <clipPath id="clip0_4152_110905">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BermudaSvg;
